import JsBarcode from 'jsbarcode';

const generateBarcodeDataUrl = (code: string, option?: JsBarcode.Options) => {
  const canvas = document.createElement('canvas');
  JsBarcode(canvas, code, {
    ...option,
  });
  return canvas.toDataURL();
};

export default generateBarcodeDataUrl;
